import { render, staticRenderFns } from "./InterventionList.vue?vue&type=template&id=6fd85b03&"
import script from "./InterventionList.vue?vue&type=script&lang=js&"
export * from "./InterventionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports